import React from "react"
import Button from "../../../../components/Button/Button"
import classNames from "classnames"
import {WireResponseAttributes} from "./types"
import {useCopyToClipboard} from "react-use"

export default function ServiceMessageResult({
	result,
	error,
	isPending,
}: {
	result: WireResponseAttributes | null
	error: string | null
	isPending: boolean
}) {
	const [, copyToClipboard] = useCopyToClipboard()
	return (
		<div className={classNames("service-message-result")}>
			<h1>Results - Response IMAD</h1>
			{isPending && <div>Loading...</div>}
			{error && <pre>{error}</pre>}
			{result && (
				<>
					<div className="wire-result-wrapper">
						<div>
							<span>IMAD</span>
							<span>{result.imad}</span>
						</div>
						<div>
							<span>Case ID</span>
							<span>{result.caseId}</span>
						</div>
					</div>
					<div className={classNames("service-message-result-button-wrapper")}>
						<Button
							prefixIcon="paginate-filter-document-copy"
							variant="outline"
							onClick={() => copyToClipboard(result.imad || "")}
						>
							Copy IMAD to Clipboard
						</Button>
						<Button
							prefixIcon="paginate-filter-document-copy"
							variant="outline"
							onClick={() => copyToClipboard(result.caseId || "")}
						>
							Copy Case ID to Clipboard
						</Button>
					</div>
				</>
			)}
		</div>
	)
}
